export default {
  SET_LOTTERY_POOL: 'SET_LOTTERY_POOL',
  ADD_WINNER: 'ADD_WINNER',
  SET_ACTIVITY_NAME: 'SET_ACTIVITY_NAME',
  SET_LOTTERY_SETTING: 'SET_LOTTERY_SETTING'
}